import { CdnFormErrors, CdnPayload } from "./types";

export const BLOCO_REGEX =
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\/(?:3[0-2]|[12]?[0-9]))?$|^(?:[A-F0-9]{1,4}:){1,7}(?::|[A-F0-9]{1,4})(?:\/(?:12[0-8]|1[01][0-9]|[1-9]?[0-9]))?$/i;

export function validateCdn(cdnItem: Partial<CdnPayload>): CdnFormErrors {
  const errors: CdnFormErrors = {};

  if (!cdnItem.as_name?.toString().trim())
    errors.as_name = "Nome é obrigatório";

  const asNum = cdnItem.as_num?.toString().trim();
  if (!asNum) errors.as_num = "ASN é obrigatório";
  else if (!/^\d+$/.test(asNum)) errors.as_num = "Informe apenas números";

  if (!cdnItem.tipo?.toString().trim()) errors.tipo = "Tipo é obrigatório";

  const bloco = cdnItem.bloco?.toString().trim();
  if (bloco && !BLOCO_REGEX.test(bloco)) errors.bloco = "Bloco inválido";

  return errors;
}
